import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "src", "size", "highlight", "highlightWidth", "className", "href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { AvatarFallbackIcon } from '../AvatarFallbackIcon';
import { isCompanyAvatarType } from '../../helpers';
import * as styles from './styles.module.css';
import { colorToValue } from '../../../../internal/utils/colorToValue';
import { OptionalAnchor } from '../../../../internal/components/OptionalAnchor';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент аватарки
 *
 * Люди - круглые
 * Компании - квадратные
 */
export var InternalAvatar = /*#__PURE__*/React.forwardRef(function InternalAvatar(_ref, ref) {
  var type = _ref.type,
    src = _ref.src,
    size = _ref.size,
    highlight = _ref.highlight,
    highlightWidth = _ref.highlightWidth,
    className = _ref.className,
    href = _ref.href,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    errorSrc = _React$useState2[0],
    setErrorSrc = _React$useState2[1];
  var isFallback = !src || errorSrc === src;
  var isCompany = isCompanyAvatarType(type);
  var isClickable = !!(href || rest.onClick);
  var handleError = function handleError() {
    setErrorSrc(src || null);
  };
  return /*#__PURE__*/_jsxs(OptionalAnchor, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: clsx(className, styles['avatar'], isCompany && styles['company'], isClickable && styles['clickable']),
    style: {
      width: size,
      height: size,
      boxShadow: highlight ? "0 0 0 ".concat(highlightWidth, "px ").concat(colorToValue(highlight)) : undefined
    },
    href: href,
    children: [isFallback && /*#__PURE__*/_jsx(AvatarFallbackIcon, {
      type: type
    }), !isFallback && /*#__PURE__*/_jsx("img", {
      src: src,
      onError: handleError,
      decoding: "async"
    })]
  }));
});